module.exports = __webpack_public_path__ + "img/sea of tranquility far side.e60d8041.png";